<template>
  <div>
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li>
          <nuxt-link :to="localePath('office-products')">
            {{
            $t("page.products")
            }}
          </nuxt-link>
        </li>
        <li>
          <nuxt-link :to="localePath('office-products-glass')">
            {{
            $t("page.glass")
            }}
          </nuxt-link>
        </li>
        <li>
          <nuxt-link :to="localePath('office-products-glass-insulating')">
            {{
            $t("page.glass_insulating")
            }}
          </nuxt-link>
        </li>

        <li class="is-active">
          <a aria-current="page">{{ $t("form.create") }}</a>
        </li>
      </ul>
    </nav>

    <form @submit.prevent="onSubmit" style="width: 100%;">
      <div class="columns">
        <div class="column">
          <field-input
            :value.sync="name"
            name="name"
            required
            :label="`${$t('form.name')}:`"
            :vvas="$t('form.name')"
          />
        </div>
        <div class="column">
          <field-select
            :value.sync="industry_id"
            name="industry_id"
            required
            :label="`${$t('form.industry')}:`"
            :vvas="$t('form.industry')"
            :options="$store.getters['industries/glassIndustries']"
          />
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <field-input
            :value.sync="delivery_time"
            name="delivery_time"
            required
            type="number"
            :label="`${$t('form.delivery_time')}:`"
            :vvas="$t('form.delivery_time')"
            :unit="$t('form.days')"
          />
        </div>
        <div class="column">
          <field-select
            :value.sync="product_class"
            name="product_class"
            required
            :label="`${$t('form.product_class')}:`"
            :vvas="$t('form.product_class')"
            :options="[{id:1, name: '1 - '+ $t('form.few_products')},2,3,4,{id:5, name: '5 - ' +$t('form.all_products')}]"
          />
        </div>
      </div>

      <div class="columns">
        <div class="column is-narrow">
          <field-checkbox
            :value.sync="available"
            name="available"
            :label="`${$t('form.available')}`"
            :vvas="$t('form.available')"
          />
        </div>
      </div>

      <div class="columns" v-if="renderedImage">
        <div class="column" style="max-width: 300px;">
          <figure class="image is-5by3">
            <img
              :src="renderedImage"
              style="object-fit: contain; object-position: left center;"
              alt
            />
          </figure>
        </div>
      </div>

      <div class="columns">
        <div class="column is-full">
          <div class="file" :class="{'has-name': image}">
            <label class="file-label">
              <input
                class="file-input"
                @change="onImageSelect"
                type="file"
                name="image"
                accept="image/*"
                v-validate="'image'"
                :data-vv-as="$t('form.image')"
              />
              <span class="file-cta" :class="{'is-loading': imageRendering}">
                <span class="file-icon">
                  <i class="mdi mdi-image-move" v-if="renderedImage"></i>
                  <i class="mdi mdi-image" v-else></i>
                </span>
                <span class="file-label" v-if="renderedImage">{{$t('message.change_image')}}</span>
                <span class="file-label" v-else>{{$t('message.choose_image')}}</span>
              </span>
              <span class="file-name" :title="image.name" v-if="image">{{image.name}}</span>
            </label>
          </div>
          <p class="help is-danger" v-if="!!this.errors.first('image')">{{ errors.first('image') }}</p>
        </div>
      </div>

      <div class="columns" v-if="renderedImage">
        <div class="column is-narrow">
          <button class="button is-danger" type="button" @click="removeImage">
            <i class="icon mdi mdi-trash-can-outline"></i>
            <span>{{$t('message.remove_image')}}</span>
          </button>
        </div>
      </div>

      <div class="field m-t-5">
        <div class="control is-clearfix">
          <button
            class="button is-primary is-pulled-right"
            :class="{ 'is-loading': formLoading }"
          >{{ $t("form.submit") }}</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      image: null,
      name: null,
      industry_id: null,
      delivery_time: null,
      product_class: null,
      available: null,
      formLoading: false,
      imageRendering: false,
      renderedImage: null
    };
  },

  methods: {
    async onSubmit() {
      const validation = await this.$validator.validateAll();
      if (!validation) return;

      this.formLoading = true;

      let formData = new FormData();

      if (this.image) {
        formData.append("image", this.image);
      }

      const {
        name,
        industry_id,
        delivery_time,
        product_class,
        available
      } = this;

      formData.append(
        "body",
        JSON.stringify({
          name,
          industry_id,
          delivery_time,
          product_class,
          available,
          type: "isolar"
        })
      );

      try {
        const { data } = await this.$api.createGlass(formData);

        this.$router.push(
          this.localePath({
            name: "office-products-glass-insulating-id",
            params: { id: data.id }
          })
        );
      } catch (e) {
        console.log(e);
        this.handleFormError(e.response.data);
      }

      this.formLoading = false;
    },

    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },

    async onImageSelect(e) {
      this.image = e.target.files[0];
      this.imageRendering = true;
      if (this.image) {
        this.renderedImage = await this.getBase64(this.image);
        this.imageRendering = false;
        return;
      }
      this.renderedImage = null;
      this.imageRendering = false;
    },

    removeImage() {
      this.image = null;
      this.renderedImage = null;
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/nuxt/pages/office/products/glass/insulating/create.vue